import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ThirdPartyHaulersComponent} from './third-party-haulers.component';

const routes: Routes = [
  {
    path: '',
    component: ThirdPartyHaulersComponent,
    data: {
      title: 'Users'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThirdPartyHaulersRoutingModule {}
